import type { ReactNode } from 'react'
import { Alert, Card } from 'antd'
import AuthLogo from './AuthLogo'

type AuthLinkLayoutProps = {
  loading?: boolean
  loadingMessage?: string
  invalidLink?: boolean
  invalidTitle?: string
  invalidDescription?: ReactNode
  invalidError?: string | null
  invalidActions?: ReactNode
  successMessage?: string
  children?: ReactNode
}

const LAYOUT_CLASS = 'min-h-screen bg-[#d1e8e8] flex flex-col items-center justify-center p-6'
const LOADING_CLASS = 'min-h-screen bg-[#d1e8e8] flex items-center justify-center'

export default function AuthLinkLayout({
  loading,
  loadingMessage = 'Verifying link...',
  invalidLink,
  invalidTitle = 'Invalid or expired link',
  invalidDescription,
  invalidError,
  invalidActions,
  successMessage,
  children = null,
}: AuthLinkLayoutProps) {
  if (loading) {
    return (
      <div className={LOADING_CLASS}>
        <div className="text-gray-700">{loadingMessage}</div>
      </div>
    )
  }

  if (invalidLink) {
    return (
      <div className={LAYOUT_CLASS}>
        <AuthLogo className="h-14 w-auto mb-6" />
        <Card className="w-full max-w-md">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">{invalidTitle}</h1>
          {invalidError && <Alert type="error" message={invalidError} className="mb-4" />}
          {invalidDescription && <p className="text-gray-600 mb-4">{invalidDescription}</p>}
          {invalidActions}
        </Card>
      </div>
    )
  }

  if (successMessage) {
    return (
      <div className={LAYOUT_CLASS}>
        <AuthLogo className="h-14 w-auto mb-6" />
        <Card className="w-full max-w-md">
          <Alert type="success" message={successMessage} showIcon />
        </Card>
      </div>
    )
  }

  return (
    <div className={LAYOUT_CLASS}>
      <AuthLogo className="h-14 w-auto mb-6" />
      {children}
    </div>
  )
}
